import { CharacterCategory, CorrectiveFeedback } from '../../../data/types';
import finishLetter from './VO34.m4a';
import finishNumber from './VO35.m4a';
import finishSymbol from './VO36-symbol.m4a';
import fasterLetter from './VO37-letter.m4a';
import fasterNumber from './VO38-number.m4a';
import fasterSymbol from './VO39-symbol.m4a';

type CorrectiveFeedbackAudio = {
  [CorrectiveFeedback.AUTOMATICITY_MEMORY]: any,
  [CorrectiveFeedback.AUTOMATICITY_SPEED]: any,
  [CorrectiveFeedback.LEGIBILITY]: null,
}

const correctiveFeedback: CorrectiveFeedbackAudio = {
  [CorrectiveFeedback.AUTOMATICITY_MEMORY]: {
    [CharacterCategory.NUMBER]: finishNumber,
    [CharacterCategory.LETTER_LOWER]: finishLetter,
    [CharacterCategory.LETTER_UPPER]: finishLetter,
    [CharacterCategory.SYMBOL]: finishSymbol,
  },
  [CorrectiveFeedback.AUTOMATICITY_SPEED]: {
    [CharacterCategory.NUMBER]: fasterNumber,
    [CharacterCategory.LETTER_LOWER]: fasterLetter,
    [CharacterCategory.LETTER_UPPER]: fasterLetter,
    [CharacterCategory.SYMBOL]: fasterSymbol,
  },
  [CorrectiveFeedback.LEGIBILITY]: null,
};

export default correctiveFeedback;
